<template>
  <div v-if="isMenuVisible" class="menu" ref="menu">
    <ul>
      <div :style="getCursorStyle(item)" v-for="(item, index) in props.menuItems" :key="index" @click="onMenuItemClick(item)">{{ item.text }}</div>
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  menuItems: {
    type: Array,
    required: true,
    default: () => []
  }
})

const isTriggeredClick = ref(false);
const isMenuVisible = ref(false);
const menu = ref(null);

const showMenu = () => {
  isMenuVisible.value = true
  isTriggeredClick.value = true

  setTimeout(() => {
    isTriggeredClick.value = false
  }, 0)
}

const hideMenu = () => {
  isMenuVisible.value = false;
}

const onMenuItemClick = (item) => {
  if (item.action) {
    item.action()
    hideMenu()
  }
}

const getCursorStyle = (item) => {
  return {
    cursor: item.action ? 'pointer' : 'unset'
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})

const handleClickOutside = (event) => {
  if (isTriggeredClick.value) {
    return
  }

  if (menu.value && !menu.value.contains(event.target)) {
    hideMenu();
  }
}

defineExpose({ showMenu, hideMenu });
</script>

<style lang="scss" scoped>
.menu {
  display: flex;
  width: 220px;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 3px;
  border: 1px solid #D8DADC;
  background: #FFF;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
}

.menu ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.menu div {
  padding-left: 12px;
  display: flex;
  height: 30px;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
  color: #2E3032;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  width: 204px;
  box-sizing: border-box;
  &:hover {
    background-color: #ECEEF0;
    border-radius: 3px;
  }
}

@media (max-width: 624px) {
  .menu {
    width: 100%;
    align-items: flex-start;
    ul {
      width: 100%;
      div {
        text-align: left;
        width: 100%;
      }
    }
  }
}
</style>